import { ReactComponent as ArrowDownIcon } from 'app/assets/img/arrow_down.svg';
import { StyledStack } from 'app/components/Stack';
import StyledButton from 'app/components/StyledButton';
import useGetApiData from 'app/hooks/useGetApiData';
import { selectTranslations } from 'app/pages/App/slice/selectors';
import { exportMyDownLoadOptions } from 'app/services/checkTicketApi';
import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import RangeDatePickerCustom from '../CheckTickets/RangeDatePickerCustom';
import StyledSelect from '../components/StyledSelect';
import moment from 'moment';

const FilesFilter = ({ onClick, setFilter }) => {
  const startDateInit = new Date(new Date().setDate(new Date().getDate() - 6));
  const translations = useSelector(selectTranslations);
  const { data } = useGetApiData({
    api: exportMyDownLoadOptions,
    params: '',
  });
  const allOtp = {
    value: '',
    label: translations?.['b2b.text.all'],
  };

  return (
    <StyledStack
      columnGap={'12px'}
      direction={{ lg: 'row', md: 'column' }}
      style={{ width: '100%', flexWrap: 'wrap' }}
      rowGap={'8px'}
    >
      <RangeDatePickerContainer>
        <RangeDatePickerCustom
          startDateInit={startDateInit}
          endDateInit={new Date()}
          onChange={value => {
            const [from_date, to_date] = value;
            setFilter(prev => ({
              ...prev,
              from_date: moment(from_date).format('YYYY-MM-DD'),
              to_date: moment(to_date ?? from_date).format('YYYY-MM-DD'),
            }));
          }}
          minDate={null}
          maxDate={new Date()}
        />
      </RangeDatePickerContainer>
      <StyledStack width={{ lg: '160px', md: '100%' }}>
        <StyledSelect
          suffixIcon={<ArrowDownIcon />}
          onChange={status => {
            setFilter(prev => ({ ...prev, status }));
          }}
          options={[allOtp, ...(data?.status || [])]}
          placeholder={translations?.['b2b.file.status']}
          style={{ width: '100%' }}
          allowClear
        />
      </StyledStack>
      <StyledStack width={{ lg: '160px', md: '100%' }}>
        <StyledSelect
          suffixIcon={<ArrowDownIcon />}
          onChange={export_type => {
            setFilter(prev => ({ ...prev, export_type }));
          }}
          options={[allOtp, ...(data?.export_type || [])]}
          placeholder={translations?.['b2b.file.classify']}
          style={{ width: '100%' }}
          allowClear
        />
      </StyledStack>
      <StyledStack width={{ lg: '124px', md: '100%' }}>
        <StyledButton
          bgColor="white"
          border="1px solid #F8B117"
          textColor="#F8B117"
          height={'44px'}
          width={'100%'}
          onClick={onClick}
        >
          {translations?.['b2c.txt.search']}
        </StyledButton>
      </StyledStack>
    </StyledStack>
  );
};

const RangeDatePickerContainer = styled.div`
  .react-datepicker__close-icon {
    right: 26px;
  }
  .date-picker {
    flex: 1;
    width: 350px;
    height: 44px;
  }
  @media (max-width: 1200px) {
    .date-picker {
      flex: 1;
      width: 100%;
      height: 44px;
    }
    .range-picker-container {
      height: 44px;
      width: 260px;
      .react-datepicker-wrapper {
        height: 100%;
        .react-datepicker__input-container {
          height: 100%;
          .date-picker {
            height: 100%;
          }
        }
      }
    }
  }
`;

export default FilesFilter;
